import { Contact } from '@ospace/contact'
import { Table, Spoiler } from '@ospace/shared'
import { ColumnDef } from '@tanstack/react-table'
import dayjs from 'dayjs'
import { Link, useLocation } from 'react-router-dom'

import { Note } from '../models/Note'

export type NoteProps = {
  notes: Note[]
}

export const Notes: React.FC<any> = (props: any) => {
  const { notes } = props

  const { pathname } = useLocation()
  const getCampaignUrl = (pathName: string) => {
    const contactPath = pathName.split('/')
    return `/${contactPath[1]}/${contactPath[2]}`
  }

  const columns: ColumnDef<Note>[] = [
    {
      accessorFn: (row: Note) => new Date(row.createdAt).getTime(),
      id: 'createdAt',
      header: 'Date',
      cell: (info: any) => dayjs(info.row.original.createdAt).format('DD MMM, YYYY'),
      size: 100,
    },
    {
      accessorFn: (row) => `${row.person?.firstName ?? ''} ${row.person?.lastName ?? ''}`.trim(),
      id: 'fullName',
      header: 'Full Name',

      cell: (info: any) => {
        const contact: Contact = info.row.original.person
        return (
          <Link
            to={`${getCampaignUrl(pathname)}/contact/${contact.id}`}
            className='text-hover-priamry cursor-pointer'
          >
            {`${contact.firstName} ${contact.lastName}`}
          </Link>
        )
      },
    },
    {
      accessorFn: (row) => row.company?.name ?? '',
      id: 'company',
      header: 'Company',

      cell: (info: any) => {
        return info.getValue()
      },
    },
    {
      accessorFn: (row: Note) => row.person?.jobTitle ?? '',
      id: 'jobTitle',
      header: 'Job Titile',

      cell: (info: any) => {
        return info.getValue()
      },
    },
    // {
    //   accessorKey: 'interactionType',
    //   header: 'Interation type',
    //   cell: (info: any) => {
    //     const status = info.getValue()
    //     return <span className='badge badge-light-success me-auto'>{status}</span>
    //   },
    //   size: 100,
    // },
    {
      accessorFn: (row: Note) => row.deal?.status ?? '',
      id: 'status',
      header: 'Status',

      cell: (info: any) => {
        return info.getValue()
      },
    },
    {
      accessorFn: (row: Note) => row.body,
      id: 'body',
      header: 'Comments',
      enableSorting: false,
      cell: (info: any) => {
        const body = info.getValue()
        const rawMarkup = (rawMarkup: string) => {
          return { __html: rawMarkup }
        }

        return (
          <Spoiler lines={6}>
            <div dangerouslySetInnerHTML={rawMarkup(body)} />
          </Spoiler>
        )
      },
      size: 400,
    },
    {
      accessorFn: (row: Note) => row.deal?.properties?.preferred_partner ?? '',
      id: 'preferred_partner',
      header: 'Preferred Partner',

      cell: (info: any) => {
        return info.getValue()
      },
    },
    {
      accessorFn: (row: Note) => row.deal?.properties?.preferred_distributors__ldr_tsa_2 ?? '',
      id: 'preferred_distributors__ldr_tsa_2',
      header: 'Preferred Distributors',

      cell: (info: any) => {
        return info.getValue()
      },
    },
  ]
  return (
    <Table
      data={notes}
      columns={columns}
      hideSearch={true}
      initialSorting={[{ id: 'createdAt', desc: true }]}
    />
  )
}
